import React from 'react'
import TimeEditor from './timeEditor'
import { capitalizeFirstLetter } from '../../../../helpers/string'
import { DeliveryHourEditRowAdder } from './deliveryHourEditRowAdder'
import { DeliveryHourEditRowRemover } from './deliveryHourEditRowRemover'
import PropTypes from 'prop-types'

export class DeliveryHourEditRow extends React.Component {

  constructor(props) {
    super(props)
    this.onStartTimeChange = this.onStartTimeChange.bind(this)
    this.onEndTimeChange = this.onEndTimeChange.bind(this)
    this.onClosedForTheDayChange = this.onClosedForTheDayChange.bind(this)
  }

  onStartTimeChange(startTime){
    this.props.row.poolTimes[this.props.index].startTime = startTime

    this.props.onChange({
      ...this.props.row,
      poolTimes: this.props.row.poolTimes
    },
    this.props.dayName)
  }

  onEndTimeChange(endTime){
    this.props.row.poolTimes[this.props.index].endTime = endTime

    this.props.onChange({
      ...this.props.row,
      poolTimes: this.props.row.poolTimes
    },
    this.props.dayName)
  }

  onClosedForTheDayChange(){
    this.props.onChange({
      ...this.props.row,
      closed: !this.props.row.closed
    },
    this.props.dayName)
  }

  render() {
    return <tr>
      <td name="dayOfWeekEdit">
        { this.props.index === 0 ? capitalizeFirstLetter(this.props.dayName) : ''}
      </td>
      <td >
        <TimeEditor name="startTimeEdit" value={this.props.row.poolTimes[this.props.index].startTime} row={this.props.row} onChange={this.onStartTimeChange} index={this.props.index} />
      </td>
      <td>
        <TimeEditor name="endTimeEdit" value={this.props.row.poolTimes[this.props.index].endTime} row={this.props.row} onChange={this.onEndTimeChange} index={this.props.index} />
      </td>
      <td>
        { this.props.index === 0 ?
          <input name="closedForTheDayEdit" type="checkbox" className="form-check-input" checked={this.props.row.closed} onChange={this.onClosedForTheDayChange}/>:
          ''
        }
      </td>
      <td>
        {
          // display button if support multiple hours
          this.props.supportMultipleHours ?
            (this.props.index === 0 ?
              <DeliveryHourEditRowAdder key={`rowAdder_${this.props.dayName}${this.props.index}`} row={this.props.row} onChange={this.props.onChange} index={this.props.index}/> :
              <DeliveryHourEditRowRemover key={`rowRemover_${this.props.dayName}${this.props.index}`} row={this.props.row} onChange={this.props.onChange} index={this.props.index}/> ) :
            ""
        }
      </td>
    </tr>

  }
}

DeliveryHourEditRow.propTypes = {
  row: PropTypes.exact({
    poolTimes: PropTypes.arrayOf(
      PropTypes.exact({
        startTime: PropTypes.string.isRequired,
        endTime: PropTypes.string.isRequired
      }).isRequired
    ),
    closed: PropTypes.bool.isRequired
  }),
  dayName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  supportMultipleHours: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired
}



// WEBPACK FOOTER //
// ./src/containers/pools/details/deliveryHours/deliveryHourEditRow.js